import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { SwitchStatus, MobileContainerAnimation, LinkAnimation } from "../../../";
import { makeStyles, Typography } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChatIcon from "@material-ui/icons/Chat";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%",
      height: "100vh"
    },
    rootIncidents: {
      minHeight: "100%"
    },
    content: {
      padding: "60px 0px 0px 0px",
      width: "100%" // bottom: 0,
      // position: "fixed",
      // height: "100%",

    },
    contentWOBreadcrumb: {
      width: "100%" // paddingBottom: "140px",
      // width: "100%",
      // position: "fixed",
      // height: "100%",

    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    iframeContainer: {
      height: "100%"
    },
    iframe: {
      width: "100%",
      height: "100%",
      border: "none",
      bottom: "0"
    },
    chatIcon: {
      marginRight: "10px"
    },
    nameContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px"
    }
  };
});

var MobileChatIframe = function MobileChatIframe(props) {
  // console.log("Chat Iframe props", props);
  var data = props.data,
      channelName = props.channelName,
      domain = props.domain,
      incidents = props.incidents,
      environment = props.environment;
  var classes = useStyles();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      iframe = _useState2[0],
      setIframe = _useState2[1];

  useEffect(function () {
    if (!environment || environment === "development") {// dev code
    } else {
      document.domain = domain;
    }
  }, []);

  var handleOnLoad = function handleOnLoad(e) {
    console.log("iframe loaded"); // console.log("e", e);
    // console.log("auth", data.auth_token);

    setIframe(document.getElementById("rocket-iframe").contentWindow);
    document.getElementById("rocket-iframe").contentWindow.postMessage({
      externalCommand: "login-with-token",
      token: data.auth_token
    }, "*" // data.chatServer
    ); // if (mode === "new") {
    //   // mode === "new" &&
    //   console.log("ChatIframe updateDirectMessages mode new");
    //   updateDirectMessages();
    // }
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: incidents ? classes.rootIncidents : classes.root
  }, props.routerState || null), !incidents && /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, props.link, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.textAnimation7s
  }, channelName || ""))), /*#__PURE__*/React.createElement("div", {
    className: incidents ? classes.contentWOBreadcrumb : classes.content
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      // props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("iframe", {
        className: classes.iframe,
        onLoad: handleOnLoad,
        src: "".concat(data.chatServer, "/").concat(data.type, "/").concat(data.room, "?layout=embedded"),
        id: "rocket-iframe" // sandbox="allow-scripts allow-popups allow-forms"

      }));
    }
  })));
};

export { MobileChatIframe }; // MobileChatIframe.propTypes = {
//   room: PropTypes.string,
//   type: PropTypes.string,
//   chatServer: PropTypes.string,
//   auth_token: PropTypes.string,
//   domain: PropTypes.string,
// };